import { Component, OnInit ,NgZone } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
import {ActivatedRoute} from '@angular/router';
declare var $;
declare var Swiper;
declare var tippy;
declare var jslib;
@Component({
  selector: 'signTime-component',
  templateUrl: './signTime.component.html'
})
export class SignTimeComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer,
    public router:ActivatedRoute,
    public ngzone: NgZone
  ) {
    super();
  }
  public BuyerID;
  public Data;
  public EventID;
  public EventData;
  public EventMap = '';
  public nowGroupIndex = 0;
  public canSignUp = true; //是否可報名
  public SignUpMsg = '';//相關提示訊息
  public btnTxt = '填寫報名表';
  ngOnInit() {
    var param = this.router.snapshot.params;
    //console.log('param',this.router.snapshot.params);
    this.BuyerID = param['id'];
    this.baseApi.apiGet('v1/buyer',{id:this.BuyerID}).then((res)=>{
      this.Data = res;
      this.RenderTagHover();
      //console.log('this.Data.sessions_group',this.Data);
      if(this.Data.sessions_group != null && this.Data.sessions_group.length > 0){
        this.SetGroup(0);
        this.SetSwiper();
      }
      this.canSignUp = true;
      this.SignUpMsg = '';
      //候補報名邏輯
      if(this.Data.hasBackup && this.Data.canBackup){
        this.canSignUp = true;
        this.SignUpMsg = '此買主洽談時段已預約額滿，僅接受候補報名。<br/>洽談會候補報名廠商如審核通過將由活動承辦人另行通知!!';
        this.btnTxt = '候補報名';
      }
      //不可報名邏輯 買主無正取，且無候補，已額滿
      if(this.Data.status == 2){
        this.canSignUp = false;
        this.SignUpMsg = '此買主洽談時段及候補報名皆額滿。';
        this.btnTxt = '已額滿';
      }
      //不可報名邏輯 買主取消
      if(this.Data.status == 3){
        this.canSignUp = false;
        this.SignUpMsg = '買主取消來台';
        this.btnTxt = '';
      }
      //不可報名邏輯 尚未開放OR報名截止OR已舉辦
      if(this.Data.status == 0 || this.Data.status == 4 || this.Data.status == 5 || this.Data.status == 9){
        this.canSignUp = false;
        this.SignUpMsg = (this.Data.status == 0 || this.Data.status == 5) ? '尚未開始報名' : '活動報名截止';
        this.btnTxt = '';
      }
      
      this.EventID = res['event_id']; 
      this.baseApi.apiGet('v1/event/' + this.EventID,{}).then((e_res)=>{
        this.EventData = e_res;
        //額外處理map
        if(this.EventData.infoItems && this.EventData.infoItems.length > 0){
          var isMap = this.EventData.infoItems.findIndex( _info =>{
            return _info['name'] == 'map';
          });
          if(isMap > -1){
          var map = this.EventData.infoItems.splice(isMap,1);
          //console.log('map',map);
          this.EventMap = map[0]['description'];
          }
        }
        //tippy
        this.ngzone.runOutsideAngular(()=>{
          setTimeout(()=>{
            //console.log('tippy');
            //doc https://atomiks.github.io/tippyjs/v6/all-props/#arrow
            window['_tip'] = tippy('#myTip', {
              placement: 'bottom',
              content(reference) {
                var html =  $('#template_how').html();
                return html;
              },
              allowHTML: true,
              //trigger: 'click',
              arrow: false,
              offset: [-20]
            });
          },500);
        });
        
      });
    });

    
    
    
  }

  SetSwiper(){
    setTimeout(()=>{
      var swiper = new Swiper('#timearea', {
        //slidesPerView: 4,
        slidesPerView: 'auto',
        spaceBetween: 20,
        grabCursor: true,
        freeMode: true
      });
    },250);
  }

  public morning = [];
  public afternoon = [];
  public selectedTimeID;
  public selectTimeItem;
  SetGroup(index){
    this.nowGroupIndex = index;
    var g = this.Data.sessions_group[index];
    
    var _nowD = this.jslib.replaceAll(g['date'].split('(')[0],'/','-');
    var filterTime = new Date(_nowD +'T12:00:00');
    this.morning = [];
    this.afternoon = [];
    var _session = g['sessions'];
    _session.forEach(time => {
      var _d =  new Date(time['sessionTime']['start']);
      if(_d <= filterTime){
        this.morning.push(time);
      }else{
        this.afternoon.push(time);
      }
    });

    //判斷暫存是否過期
    var _history = this.jslib.GetStorage('time');
    if(_history != null && typeof _history != 'undefined'){
      var isExist = _session.find((_s)=>{return _s['session_id'] == _history['session_id']});
      if(typeof isExist == 'undefined'){
        this.selectedTimeID = null;
        this.selectTimeItem = null;
        this.jslib.SetStorage('time',null);
      }
    }

    //20210119 若為登入狀態，且有紀錄，且紀錄為有效，轉填報名表，否則清除
    var islogin = this.baseApi.IsLogin();
    if(islogin && this.canSignUp == true){
      var history = this.jslib.GetStorage('time');
      if(history && history['available'] == true){
        this.TimeSelect(history);
        this.GoCheck();
      }
    }else{
      this.jslib.SetStorage('time',null);//清除時間暫存
    }

  }
  
  TimeSelect(item){
    //console.log('TimeSelect',item);
    if(item['available']){
      if(item['session_id'] == this.selectedTimeID){
        this.selectedTimeID = null;
        this.selectTimeItem = null;
        this.jslib.SetStorage('time',null);
      }else{
        this.selectedTimeID = item['session_id'];
        this.selectTimeItem = item;
        this.jslib.SetStorage('time',item);
      }
    }else{
      this.selectedTimeID = null;
      this.selectTimeItem = null;
      this.jslib.SetStorage('time',null);
    }
  }
  public IsShow = false;
  ToggleCard(){
    this.IsShow = !this.IsShow;
  }
  GoCheck(){
    var islogin = this.baseApi.IsLogin();
    if(islogin){
      //先驗證可報名
      if(this.Data.sessions_group != null){
        if(this.selectTimeItem){
          this.route.navigateByUrl('/member/signCheck/' + this.BuyerID);
        }else{
          this.pop.setConfirm('請選擇報名時段!');
        }
      }else{
        //是否候補報名
        if(this.Data.hasBackup && this.Data.canBackup){
          this.route.navigateByUrl('/member/signCheck/' + this.BuyerID);
        }else{
          this.pop.setConfirm('此買主洽談時段及候補報名已預約額滿。');
        }
      }
      
    }else{
      this.pop.setConfirm({
        content:'請先登入後<br/>才能預約買主',
        cancelTxt:'取消',
        checkTxt:'前往登入',
        event:()=>{
          //轉往登入
          this.baseApi.RedirectSSO();
        }
      });
    }

    
  }
  RenderTagHover(){
    setTimeout(()=>{
      this.ngzone.runOutsideAngular(()=>{

        window['tag_tip'] = 
          tippy('.hoverEvt span', {
            content: 'Loading...',
            theme:'tag',
            //trigger: 'click',
            allowHTML: true,
            interactive: true,
            onShow(instance) {
                var dom = instance['reference'];
                var param = {
                  txt : dom.innerText,
                  desc : dom.dataset.desc,
                  spec : dom.dataset.spec,
                  attach : dom.dataset.attach,
                  pid : dom.dataset.pid,
                  buyer : dom.dataset.buyer,
                  islogin : false
                };
                param.islogin = jslib.GetStorage('user') != null;
                ////console.log('instance param',param);
                var html = '<div class="tag_pop">';
                html += '<label>' +  param.txt + '</label>';
                
                //尚未登入顯示
                if(param.spec == 'false' && param.islogin == false){
                  html += '<p>登入查看詳細規格</p>';
                  html += '<div class="bottom"><span></span><span class="add" onclick="ToLogIn()"><i class="lock"></i>立即登入</span></div>';
                }else{
                  html += '<p>' + param.desc +  '</p>';
                  if(param.attach == 'true' && param.islogin){
                    var _url = '/brochure/download?buyer_id=' + param.buyer + '&product_id=' + param.pid;
                    html += '<div class="bottom"><span><i class="icon icon-attach-file">&#xe80a;</i><a href="' + _url + '" target="_blank">下載檔案</a></span><span class=""></span></div>';
                  }else{
                    html += '<div class="bottom"><span></span><span class="add"></span></div>';
                  }
                  html += '</div>';
                }

                instance.setContent(html);
              },
          });

      });
    },250);
  }
  TagAddFilter(){
    window['ToLogIn'] = ()=>{
      this.baseApi.RedirectSSO();
    }
  }
}
